/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResponseStatus {
    Ok = 'OK',
    Ko = 'KO'
}

export function ResponseStatusFromJSON(json: any): ResponseStatus {
    return ResponseStatusFromJSONTyped(json, false);
}

export function ResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseStatus {
    return json as ResponseStatus;
}

export function ResponseStatusToJSON(value?: ResponseStatus | null): any {
    return value as any;
}

